import { SELL_API as axios } from '@services/axiosInstance';
import type { ShoppingCartDTO } from '@t/api.types';

const couponPath = (sessionId: string): string => `/sessions/${sessionId}/shopping-cart/coupon`;

export const applyCoupon = async (sessionId: string, couponCode: string): Promise<ShoppingCartDTO> => {
  const { data } = await axios.post<ShoppingCartDTO>(`${couponPath(sessionId)}/${couponCode}`);
  return data;
};

export const removeCoupon = async (sessionId: string): Promise<ShoppingCartDTO> => {
  const { data } = await axios.delete<ShoppingCartDTO>(couponPath(sessionId));
  return data;
};
